import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {EntityKey} from '../entity/entity';
import {TagSaveResponse} from '../tags/tag-save-response';
import {UnitTaggingRow} from '../model/unit-tagging-row';
import {UnitTaggingSaveRequest} from '../model/unit-tagging-save-request';
import {GoogleService} from './google-service';

@Service()
export class TagService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private urlBase = environment.serviceUrl;

  getTagTemplate(id: EntityKey): Observable<Blob> {
    const url = this.urlBase + 'tagging/template/' + id.entityId + '/' + id.entityRevision;
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], {type: response.headers.get('Content-Type')});
    }));
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  saveTags(key: EntityKey, ignoreWarning: boolean, includeShippingTags: boolean, fileBytes: Uint8Array): Observable<TagSaveResponse> {
    const url = this.urlBase + 'tagging/save/' + key.entityId + '/' + key.entityRevision + '?ignoreWarnings=' + ignoreWarning + '&includeShippingTags=' + includeShippingTags;
    return this.http.post<TagSaveResponse>(url, fileBytes, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/octet-stream");
  }

  getUnits(id: EntityKey): Observable<UnitTaggingRow[]> {
    const url = this.urlBase + 'tagging/units/' + id.entityId + '/' + id.entityRevision;
    return this.http.get<UnitTaggingRow[]>(url, {headers: this.getRequestHeaders()});
  }

  saveUnits(key: EntityKey, ignoreWarning: boolean, includeShippingTags: boolean, rows: UnitTaggingRow[]): Observable<TagSaveResponse> {
    const url = this.urlBase + 'tagging/units';
    const request: UnitTaggingSaveRequest = {
      entityId: key.entityId,
      entityRevision: key.entityRevision,
      includeShippingTags: includeShippingTags,
      ignoreWarnings: ignoreWarning,
      updateUser: '',
      units: rows
    };
    return this.http.post<TagSaveResponse>(url, request, {headers: this.getJsonPostHeaders()});
  }

  private getJsonPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

}
